import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div>
        <section className="colorlib-about" data-section="about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-12">
                <div className="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                <div className="col-md-12">
                    <div className="about-desc">
                    <span className="heading-meta"></span>
                    <h2 className="colorlib-heading">Who Am I?</h2>
                    <p>I am a Full Stack Engineer at Cisco Meraki, where I build software for the Meraki Dashboard —
                        a platform serving over 500,000 organizations. I graduated from Queen's University in 2022 with a degree
                        in Mathematics and Engineering, Computing and Communications. </p>
                    <p>I started my career at Meraki as a Firmware Engineer, writing C/C++ for Linux-based networking switches,
                        before moving to the full stack team, where I work with React and TypeScript on the front-end, Ruby on Rails on the backend,
                        and object-oriented Scala services running on Kubernetes. As a Canadian citizen eligible for the UK Youth Mobility Scheme,
                        I am currently pursuing software engineering opportunities in the United Kingdom.</p>
                    <p>In my free time I have spent my life skiing and sailing, spending 6+ years applying my in-depth knowledge to coach children
                        in both sports, which allowed them to get the best start and master their skills. </p>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
        <section className="colorlib-about">
        <div className="colorlib-narrow-content">
            <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
                <span className="heading-meta"></span>
                <h2 className="colorlib-heading">My Skillset</h2>
            </div>
            </div>
            <div className="row row-pt-md">
            <div className="col-md-4 text-center animate-box">
                <div className="services color-1">
                <span className="icon">
                    <i className="icon-phone3" />
                </span>
                <div className="desc">
                    <h3>Full Stack Development</h3>
                    <p>On the Meraki Dashboard I build features with React and TypeScript, Ruby on Rails, and Scala services on Kubernetes —
                        including switch-configuration systems that push NETCONF transactions to millions of deployed switches.</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-3">
                <span className="icon">
                    <i className="icon-bulb" />
                </span>
                <div className="desc">
                    <h3>Embedded & Firmware</h3>
                    <p>As a Firmware Engineer at Cisco Meraki I debugged and shipped C/C++ firmware for Linux-based switch products,
                        built test labs that accelerated defect isolation by 30%, and developed embedded software for BLE, LTE, and GPS.</p>
                </div>
                </div>
            </div>
            <div className="col-md-4 text-center animate-box">
                <div className="services color-5">
                <span className="icon">
                    <i className="icon-data" />
                </span>
                <div className="desc">
                    <h3>Data & Analytics</h3>
                    <p>I investigate fleet-wide behaviour with SQL and Snowflake, built automated Power BI reporting at Fasken LLP that saved
                        20 hours per month, and ran aerodynamic simulations in OpenFOAM (C++) on the Queen's Formula SAE car.</p>
                </div>
                </div>
            </div>

            </div>
        </div>
        </section>
      </div>
    )
  }
}
